class GlobalState {
    private state: { [key: string]: any } = {};
    private listeners: { [key: string]: Array<() => void> } = {};

    getState(key: string) {
        return this.state[key];
    }

    setState(key: string, value: any) {
        this.state[key] = value;
        this.notifyListeners(key);
    }

    subscribe(key: string, listener: () => void) {
        if (!this.listeners[key]) {
            this.listeners[key] = [];
        }
        this.listeners[key].push(listener);
    }

    unsubscribe(key: string, listener: () => void) {
        if (!this.listeners[key]) return;
        this.listeners[key] = this.listeners[key].filter((l) => l !== listener);
    }

    private notifyListeners(key: string) {
        if (!this.listeners[key]) return;
        this.listeners[key].forEach((listener) => listener());
    }
}

export const globalState = new GlobalState();
